export const CONTACTS_TYPE = {
    BLOCK: "block",
    FRIEND: "friend",
};
